import { Alert, ColoredAlert } from '@bpinternal/ui-kit-next'
import type { FC } from 'react'

import { CodeSnippet } from '~/components'
import { ConfigSection } from '~/features/webchat/components'

type Props = {
  embedScript: string | null | undefined
  shareableLink: string | null | undefined
}

export const ShareConfig: FC<Props> = ({ embedScript, shareableLink }) => {
  return (
    <div className="flex flex-col gap-6">
      <ConfigSection
        title="Shareable Link"
        description="Share the following link with people that would like to quickly test your chatbot."
        linkUrl={shareableLink ?? ''}
        linkLabel="View"
      >
        {shareableLink === null ? (
          <ColoredAlert color="blue">Your webchat is not yet configured. Please configure it first.</ColoredAlert>
        ) : (
          <CodeSnippet code={shareableLink ?? ''} />
        )}
      </ConfigSection>
      <ConfigSection
        title="Embed code"
        description="Copy and paste this code on your webpage."
        linkUrl="https://botpress.com/docs/webchat/get-started/quick-start"
        linkLabel="Documentation"
      >
        {embedScript === null ? (
          <Alert className="border border-blue-400 bg-blue-50 text-blue-700">
            Your webchat is not yet configured. Please configure it first.
          </Alert>
        ) : (
          <CodeSnippet code={embedScript ?? ''} />
        )}
      </ConfigSection>
    </div>
  )
}
